function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import { withIconWrapper } from '../../components/atoms/Icon/withIconWrapper';
import { jsx as ___EmotionJSX } from "@emotion/react";

var IllustrationCloud = function IllustrationCloud(props, ref) {
  return ___EmotionJSX("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "355",
    height: "110",
    viewBox: "0 0 355 110",
    fill: "none",
    stroke: "none",
    ref: ref
  }, props), ___EmotionJSX("path", {
    opacity: "0.9",
    d: "M13.3719 109.8L340.314 107.858C346.674 107.824 352.105 103.281 353.253 97.0317C356.053 81.7979 354.197 54.9613 309.814 47.2937C306.491 46.7195 303.472 44.9461 301.447 42.2439C288.677 25.2874 236.366 -33.7396 165.363 26.4358C162.04 29.2563 157.57 30.3203 153.369 29.1887C136.129 24.5611 88.9291 15.9646 57.3163 49.3541C57.3163 50.1142 18.0447 56.8191 1.34416 90.8335C-2.95748 99.6157 3.60464 109.85 13.3719 109.8Z",
    fill: "white"
  }));
};

export default withIconWrapper( /*#__PURE__*/forwardRef(IllustrationCloud));
//# sourceMappingURL=IllustrationCloud.js.map